import { ChatBubbleSolidIcon, PlusIcon } from '@shared/assets/icons';
import { EditParticipantTextModal } from '@features/clients';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { ClientInfo } from '@entities/clients';
import styles from './styles.module.scss';
import { useState } from 'react';
import clsx from 'clsx';

interface FioCellProps {
  clientInfo?: ClientInfo;
  onChangeMobileComment: (mobileComment: string) => void;
  calls?: boolean | null;
}

export const FioCell = ({ clientInfo, onChangeMobileComment, calls }: FioCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { FIO, mobileComment } = clientInfo || {};

  return (
    <div className={styles.container}>
      <span className={clsx(styles.fio, calls && styles.calls)}>{FIO}</span>

      <UnstyledButton
        className={clsx(styles.mobileComment, mobileComment && styles.hasComment)}
        onClick={() => setIsModalOpen(true)}
      >
        {mobileComment ? <ChatBubbleSolidIcon /> : <PlusIcon width="12" height="12" />}
        Заметка для хостес
      </UnstyledButton>

      {isModalOpen && (
        <EditParticipantTextModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={onChangeMobileComment}
          title="Добавить заметку для хостес"
          participantName={FIO || ''}
          value={mobileComment || ''}
          placeholder="Введите комментарий"
          fieldLabel="Ваш комментарий"
        />
      )}
    </div>
  );
};
